import React, { useEffect } from 'react';

const CacheBuster = () => {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Fetch the meta.json file from the server
        const response = await fetch(`/meta.json?t=${new Date().getTime()}`, {
          cache: 'no-store'
        });
        const latestMeta = await response.json();
        
        // Get the current version stored in localStorage
        const currentVersion = localStorage.getItem('app_version');

        if (latestMeta && latestMeta.version) {
          if (!currentVersion) {
            // First time loading, set the version
            localStorage.setItem('app_version', latestMeta.version);
          } else if (currentVersion !== latestMeta.version.toString()) {
            // New version detected
            console.log('New version available. Refreshing...');
            localStorage.setItem('app_version', latestMeta.version);
            
            // Clear browser cache and reload
            if ('serviceWorker' in navigator) {
              const registrations = await navigator.serviceWorker.getRegistrations();
              for (let registration of registrations) {
                await registration.unregister();
              }
            }
            
            // Reload the page from server
            window.location.reload(true);
          }
        }
      } catch (error) {
        console.error('Error checking for version update:', error);
      }
    };

    // Check once on mount
    checkVersion();

    // Check every 30 minutes
    const interval = setInterval(checkVersion, 1800000);

    return () => clearInterval(interval);
  }, []);

  return null;
};

export default CacheBuster;
